import { useState } from 'react';
import { BiLock, BiX, BiCheck } from 'react-icons/bi';

const PinConfirmation = ({
    isOpen,
    onConfirm,
    onCancel,
    title = "Confirmação de Segurança",
    description = "Digite o PIN de segurança para confirmar a entrada dos equipamentos no estoque",
    warningTitle = "Operação Crítica",
    warningText = "Esta ação irá registrar permanentemente os equipamentos no sistema de patrimônio."
}) => {
    const [pin, setPin] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const PIN_CORRETO = '04530453#';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (pin === PIN_CORRETO) {
            onConfirm();
            handleClose();
        } else {
            setError('PIN incorreto. Tente novamente.');
            setPin('');
        }
        setLoading(false);
    };

    const handleClose = () => {
        setPin('');
        setError('');
        setLoading(false);
        onCancel();
    };

    const handlePinChange = (e) => {
        const value = e.target.value;
        // Permitir apenas números e o símbolo #
        if (/^[0-9#]*$/.test(value)) {
            setPin(value);
            if (error) setError('');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={handleClose}></div>
            
            <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-md">
                <BiX 
                    onClick={handleClose} 
                    className="absolute top-4 right-4 w-6 h-6 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer transition-colors duration-200" 
                />
                
                <div className="p-6">
                    <div className="flex items-center justify-center mb-6">
                        <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center">
                            <BiLock className="w-8 h-8 text-orange-600" />
                        </div>
                    </div>

                    <h2 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-2">
                        {title}
                    </h2>
                    
                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center mb-6">
                        {description}
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                PIN de Segurança
                            </label>
                            <input
                                type="password"
                                value={pin}
                                onChange={handlePinChange}
                                placeholder="Digite o PIN"
                                maxLength={10}
                                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-center text-lg font-mono tracking-wider ${
                                    error 
                                        ? 'border-red-500 bg-red-50 dark:bg-red-900/20' 
                                        : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700'
                                } text-gray-900 dark:text-white`}
                                autoFocus
                                disabled={loading}
                            />
                            {error && (
                                <p className="mt-2 text-sm text-red-600 dark:text-red-400 text-center">
                                    {error}
                                </p>
                            )}
                        </div>

                        <div className="flex space-x-3 pt-4">
                            <button
                                type="button"
                                onClick={handleClose}
                                className="flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg font-medium hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors duration-200"
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="flex-1 flex items-center justify-center px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                disabled={loading || !pin}
                            >
                                {loading ? (
                                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                ) : (
                                    <>
                                        <BiCheck className="w-5 h-5 mr-1" />
                                        Confirmar
                                    </>
                                )}
                            </button>
                        </div>
                    </form>

                    <div className="mt-6 p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800">
                        <div className="flex items-start">
                            <svg className="w-5 h-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            <div>
                                <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                                    {warningTitle}
                                </h3>
                                <p className="text-xs text-yellow-700 dark:text-yellow-300 mt-1">
                                    {warningText}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PinConfirmation;
